const AddResource = ({ title, red }) => {
  return (
    <div className="pb-5 flex flex-col sm:flex-row items-center justify-between">
      <h3
        className={`${
          red ? "text-red-500 " : " text-text-1 "
        }  font-bold text-xl sm:text-xl text-center sm:text-left`}
      >
        {title}
      </h3>
      <div></div>
    </div>
  );
};

export default AddResource;
